import Vue from 'vue';
import { RelatedPostsParams } from '@/models/params/relatedPostsParams';
import { Post } from '@/models/dtos';
import { StoreObjectList } from '@/store/storeObject';

export default Vue.extend({
	props: {
		disableLoader: {
			type: Boolean,
			default: false,
		},
		postId: {
			type: Number,
			required: true,
		},
		postTemplateIds: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			relatedParams: {
				postId: this.postId,
				postTemplateIds: this.postTemplateIds,
			} as RelatedPostsParams,
		};
	},
	computed: {
		posts(): StoreObjectList<Post> {
			return this.$store.getters.postsByParams(this.relatedParams);
		},
	},
	async created() {
		await this.$store.dispatch('loadRelatedPosts', this.relatedParams);
	},
});
